import { render } from "./PostRead.vue?vue&type=template&id=b449e530&scoped=true"
import script from "./PostRead.vue?vue&type=script&lang=js"
export * from "./PostRead.vue?vue&type=script&lang=js"

import "./PostRead.vue?vue&type=style&index=0&id=b449e530&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b449e530"]])

export default __exports__